import React from 'react';
import { digits } from '../../utils/sanitaize';

export interface ExportData {
  filename: string;
  version: string;
  file: File;
  oldName?: string;
}

export interface ActionFileProps {
  freez?: 'create' | 'update' | 'delete';
}

export interface ActionFileState extends ExportData {
  freez?: 'create' | 'update' | 'delete';
  errors: {
    filename?: string;
    version?: string;
    file?: string;
  }
}

abstract class ActionFile<P extends ActionFileProps, S extends ActionFileState> extends React.Component<P, S> {

  state = {
    filename: (this.props as any).filename ?? '',
    version: (this.props as any).version ?? '',
    file: null,
    freez: null,
    errors: {
    }
  } as S;

  protected renderFreez = (equals: string) => {
    if (this.state.freez === equals) {
      return <i className="fad fa-spinner-third fa-spin ml-1"></i>;
    }
    return '';
  }

  protected freezDisabled = (equals: string) => {
    if (this.state.freez === equals) {
      return true;
    }
    return false;
  }

  protected invalidCheckClass = (key: string) => (this.state.errors[key]) ? ' is-invalid' : '';

  protected handleFileChange = (file: File) => {
    if (this.state.filename.trim() === '') {
      const { file: _efile, filename: _efilename, ...rest } = this.state.errors;
      return this.setState({ file, filename: file.name, errors: { ...rest } });
    }
    const { file: _efile, ...rest } = this.state.errors;
    this.setState({ file, errors: { ...rest } });
  };

  protected handleVersionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = digits(e.target.value);
    if (value !== '' && /^[0-9\b]+$/.test(value) === false) {
      return e.preventDefault();
    }
    this.setState({ version: value }, () => {
      if (this.state.version !== '' && this.state.errors.version) {
        this.unsetError('version');
      }
    });
  }

  protected handleFilenameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    this.setState({ filename: value }, () => {
      if (this.state.filename !== '' && this.state.errors.filename) {
        this.unsetError('filename');
      }
    });
  }

  protected validate = (): boolean => {
    const errors: any = {};
    let { filename, file } = this.state;
    filename = filename.trim();
    if (filename === '') {
      errors.filename = 'نام فایل نمیتواند خالی باشد';
    }
    /*
    version = this.state.version.trim();
    if (version === '') {
      errors.version = 'ورژن نمیتواند خالی باشد';
    }
    */
    if (file === null) {
      errors.file = 'فایل یک فیلد اجباری است';
    }
    if (Object.keys(errors).length > 0) {
      this.setState({ errors });
      return false;
    }
    else {
      this.setState({ errors: {} });
    }
    return true;
  }

  protected unsetError = (keys: string | string[]) => {
    if (!Array.isArray(keys)) {
      keys = [keys];
    }
    const errors = { ...this.state.errors };
    for (const item of keys) {
      if (errors[item]) {
        errors[item] = undefined;
        delete errors[item];
      }
    }
    this.setState({ errors });
  }

}

export default ActionFile;
